/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// React
import React, { forwardRef, useEffect } from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// custom components
import ComponentArray from "../component-breakdown/ComponentArray";
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";

const defaultValues = [
  {
    image: "",
    title: "",
    elements: [
      { 
        title: "",
        attrs: [
          {
            property: "",
            value: ""
          }
        ]
      }
    ]
  },
];

function ComponentsForm(props) {
  const methods = useFormContext();
  const { control, formState, register } = methods;
  const { errors } = formState;
  
  return (
    <>
      <LeadNumberedHeading number="5" title="Component Breakdown" instructions="This information is used to store the information for the components needed to compose the template." />

      <div className="flex flex-col w-full">
        <Controller
          control={control}
          name="components"
          render={({ field }) => <ComponentArray {...{ control, register, defaultValues, errors }} />}
        />
      </div>
    </>
  );
};

export default ComponentsForm;